module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-plano-in-plano-texas-88f436793dd5b9daecefa2d009b5d950.png";